if (!customElements.get('bb-mobile-purchase')) {
  customElements.define('bb-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.root = document.querySelector('[data-section-type="product"]');
      if (!this.root) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
      };
      this.observer = new MutationObserver(schedule);
      this.observer.observe(document.querySelector('#MainContent') || this.root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class', 'value', 'checked'] });
      window.addEventListener('scroll', schedule, { passive: true, signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
      this.root.addEventListener('change', schedule, { signal });
      this.root.addEventListener('input', schedule, { signal });
      this.querySelector('[data-bb-buy]').addEventListener('click', () => {
        const button = this.root.querySelector('[data-product-form] [data-add-to-cart]');
        if (button && !button.disabled && !button.classList.contains('loading')) {
          this.querySelector('[data-bb-buy]').disabled = true;
          button.click();
          schedule();
        }
      }, { signal });
      this.querySelector('[data-bb-selection]').addEventListener('click', () => {
        const target = this.root.querySelector('.product__block__variants') || this.root.querySelector('[data-product-form]');
        if (!target) return;
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        const control = target.querySelector('input:checked,select,button');
        control?.focus({ preventScroll: true });
      }, { signal });
      this.sync();
    }
    sync() {
      this.root = document.querySelector('[data-section-type="product"]');
      const main = this.root?.querySelector('[data-product-form] [data-add-to-cart]');
      if (!main) { this.hidden = true; return; }
      const price = main.querySelector('[data-button-price]')?.textContent.trim() || '';
      const label = main.querySelector('[data-add-to-cart-text]')?.textContent.trim() || main.getAttribute('aria-label') || '';
      const selection = Array.from(this.root.querySelectorAll('input[type="radio"][name^="options["]:checked, select[name^="options["]')).map(el => el.value).join(' / ');
      this.querySelector('[data-bb-price]').textContent = price;
      this.querySelector('[data-bb-button]').textContent = label;
      this.querySelector('[data-bb-choice]').textContent = selection || this.dataset.productName;
      this.querySelector('[data-bb-change]').textContent = selection ? this.dataset.changeLabel : this.dataset.viewLabel;
      this.querySelector('[data-bb-buy]').disabled = main.disabled || main.classList.contains('loading');
      this.hidden = !matchMedia('(max-width: 749px)').matches || main.getBoundingClientRect().bottom >= 0;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}
if (!customElements.get('bb-review-preview')) {
  customElements.define('bb-review-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      const container = document.querySelector('#MainContent');
      if (!container) return;
      const bind = () => {
        const widget = container.querySelector('#vstar-reviews');
        const list = widget?.querySelector('.tt-review-list');
        if (!list) return;
        if (this.widget !== widget) {
          this.widget = widget;
          widget.classList.add('bf-reviews-compact');
        }
        let button = widget.querySelector('[data-bb-review-toggle]');
        if (!button) {
          button = document.createElement('button');
          button.type = 'button';
          button.className = 'bf-review-toggle';
          button.dataset.bbReviewToggle = '';
          button.textContent = this.dataset.more;
          button.setAttribute('aria-expanded', 'false');
          button.setAttribute('aria-controls', 'reviews-body');
          button.addEventListener('click', () => {
            const expanded = widget.classList.toggle('bf-reviews-expanded');
            button.setAttribute('aria-expanded', String(expanded));
            button.textContent = expanded ? this.dataset.less : this.dataset.more;
            if (!expanded) widget.scrollIntoView({ block: 'start', behavior: 'auto' });
          });
          const pagination = widget.querySelector('.page-control');
          if (pagination) pagination.before(button); else widget.append(button);
        }
        button.hidden = list.querySelectorAll('.list-review').length <= 3;
      };
      this.observer = new MutationObserver(bind);
      this.observer.observe(container, { childList: true, subtree: true });
      bind();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.observer = null; }
  });
}
